import React from 'react';
import {ConfigProvider} from 'antd';
import {ToastContainer} from 'react-toastify';
import Main from "./components/Main";
import {PresenceProvider} from "./context/PresenceContext";

const App = () => {
    return (
        <ConfigProvider theme={{token: {colorTextPlaceholder: 'black'}}}>
            <PresenceProvider>
                <div className="App">
                    <ToastContainer/>
                    <Main/>
                </div>
            </PresenceProvider>
        </ConfigProvider>
    );
}

export default App;
